import React from "react";
import IncomingAccessRequestAccordion from "../../components/AccessRequestAccordion/IncomingAccessRequestAccordion";
import AccessRequestAccordion from "../../components/AccessRequestAccordion/MyAccessRequestAccordion";
import Panel from "components/odl-v2/Layout/Panel";
import Spacer from "components/Spacer/Spacer";
import { css } from "@emotion/react";
import { styled } from "@mui/material/styles";
import Section from "components/Layout/Section";

type Props = {};

const AccessRequestSection: React.FC<Props> = () => {
  return (
    <Section data-testid={"AccessRequestSection"}>
      <StyledPanel thickness={"thin"} hasInnerContainer={false}>
        <IncomingAccessRequestAccordion />
        <Spacer y={4} />
        <AccessRequestAccordion />
      </StyledPanel>
    </Section>
  );
};

const StyledPanel = styled(Panel)(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
  `
);

export default AccessRequestSection;
